/**
 * 系统配置参数
 * 仅针对文件：utils/request.js和router/index.js
 */
const setting = {
  // 项目名称
  projectName: 'TyVideos',
  // 开启防重复提交
  repeatSubmit: {
    enabled: true,
    duration: 1000 //毫秒
  },
  // 开启顶部进度条
  progressBar: {
    enabled: true
  },
  // 开启Loading效果
  loadingEffect: {
    enabled: true,
    text: '加载中'
  },
  // 路由模式（history/hash）
  routerMode: 'history',
  // 免检验的路由白名单列表（请填写路由的name值）
  routesWhiteList: ['Login', 'Register', 'Forget'],
  // 一些重要的路由页面
  routerPath: {
    login: { //登录页面
      name: 'Login',
      path: '/login',
    },
    lock: { //锁屏页面
      enabled: true,
      name: 'Lock',
      path: '/lock'
    },
    error: { //错误页面
      err401Path: '/401',
      err404Path: '/404'
    }
  },
  // 设置Header参数名
  headers: {
    tokenName: 'Authorization',
    contentType: {
      name: 'Content-Type',
      value: 'application/x-www-form-urlencoded'
    }
  }
}
module.exports = setting


// WEBPACK FOOTER //
// ./src/config/setting.js